module.exports = __webpack_public_path__ + "img/badge-myelogramme-03.cf1ce3be.png";